import React, {useState, useEffect, useRef, useReducer} from "react";
import UploadService from "../services/FileUploadService";


const UploadImages = (props) => {
    const [selectedFiles, setSelectedFiles] = useState(undefined);
    const [imagePreviews, setImagePreviews] = useState([]);
    const [progressInfos, setProgressInfos] = useState({ val: [] });
    const [message, setMessage] = useState([]);
    //const [imageInfos, setImageInfos] = useState([]);
    const progressInfosRef = useRef(null);


    // useEffect(() => {
    //     if(props.codigo !== ""){
    //         UploadService.getFiles(props.codigo).then((response) => {
    //             console.log(response);
    //             let images = [];
    //             if(response.data.length !== 0){
    //                 images.push(response.data.foto1);
    //                 images.push(response.data.foto2);
    //                 images.push(response.data.foto3);
    //                 images.push(response.data.foto4);
    //                 setImageInfos(images);
    //             }
    //             setImageInfos(images);
    //         });
    //     }
    // }, []);

    const selectFiles = (event) => {
        let images = [];

        for (let i = 0; i < event.target.files.length; i++) {
            images.push(URL.createObjectURL(event.target.files[i]));
        }

        setSelectedFiles(event.target.files);
        setImagePreviews(images);
        setProgressInfos({ val: [] });
        setMessage([]);
    };

    const upload = (idx, file) => {
        let _progressInfos = [...progressInfosRef.current.val];
        return UploadService.upload(props.codigo, idx, file, (event) => {
            _progressInfos[idx].percentage = Math.round(
                (100 * event.loaded) / event.total
            );
            setProgressInfos({ val: _progressInfos });
        })
            .then(() => {
                setMessage((prevMessage) => [
                    ...prevMessage,
                    "Imagen cargada exitosamente: " + file.name,
                ]);
            })
            .catch(() => {
                _progressInfos[idx].percentage = 0;
                setProgressInfos({ val: _progressInfos });

                setMessage((prevMessage) => [
                    ...prevMessage,
                    "No se pudo cargar la imagen: " + file.name,
                ]);
            });
    };

    const uploadImages = () => {
        const files = Array.from(selectedFiles);
        if(files.length < 4){
            alert("Debe seleccionar 4 imágenes, intente de nuevo");
            return;
        }
        let _progressInfos = files.map((file) => ({
            percentage: 0,
            fileName: file.name,
        }));

        progressInfosRef.current = {
            val: _progressInfos,
        };

        const uploadPromises = files.map((file, i) => upload(i, file));

        Promise.all(uploadPromises)
            .then(() => UploadService.getFiles(props.codigo))
            .then((files) => {
                //setImageInfos(files.data);
                setImagePreviews([]);
                setMessage([]);
                setProgressInfos({ val: [] });
                alert("Proceso finalizado, recargue la página");
            });

        setMessage([]);
    };

    return (
        <div>
            <div className="row">
                <div className="col-8">
                    <label className="btn btn-default p-0">
                        <input
                            type="file"
                            multiple
                            accept="image/*"
                            onChange={selectFiles}
                        />
                    </label>
                </div>

                <div className="col-4">
                    <button
                        className="btn btn-success btn-sm"
                        disabled={!selectedFiles}
                        onClick={uploadImages}
                    >
                        Cargar imagenes
                    </button>
                </div>
            </div>

            {progressInfos &&
                progressInfos.val.length > 0 &&
                progressInfos.val.map((progressInfo, index) => (
                    <div className="mb-2" key={index}>
                        <span>{progressInfo.fileName}</span>
                        <div className="progress">
                            <div
                                className="progress-bar progress-bar-info"
                                role="progressbar"
                                aria-valuenow={progressInfo.percentage}
                                aria-valuemin="0"
                                aria-valuemax="100"
                                style={{ width: progressInfo.percentage + "%" }}
                            >
                                {progressInfo.percentage}%
                            </div>
                        </div>
                    </div>
                ))}

            {imagePreviews && (
                <div>
                    <h3 className="page-title mb-lg"><span className="fw-semi-bold">Evidencias a guardar</span></h3>
                    {imagePreviews.map((img, i) => {
                        return (
                            <img className="preview" src={img} alt={"image-" + i} key={i} height="400px" width="400px"
                                 style={{
                                     border: '20px solid #B0B6B0',
                                 }}
                            />
                        );
                    })}
                </div>
            )}

            {message.length > 0 && (
                <div className="alert alert-secondary mt-2" role="alert">
                    <ul>
                        {message.map((item, i) => {
                            return <li key={i}>{item}</li>;
                        })}
                    </ul>
                </div>
            )}

            {/*{imageInfos.length > 0 && (*/}
            {/*    <div className="card mt-3">*/}
            {/*        <div className="card-header">List of Images</div>*/}
            {/*        <ul className="list-group list-group-flush">*/}
            {/*            {imageInfos &&*/}
            {/*                imageInfos.map((img, index) => (*/}
            {/*                    <li className="list-group-item" key={index}>*/}
            {/*                        <p>*/}
            {/*                            <a href={img.url}>{img.name}</a>*/}
            {/*                        </p>*/}
            {/*                        <img src={img.url} alt={img.name} height="80px" />*/}
            {/*                    </li>*/}
            {/*                ))}*/}
            {/*        </ul>*/}
            {/*    </div>*/}
            {/*)}*/}
        </div>
    );
};

export default UploadImages;